/**
 * Popup de boas-vindas (cadastro + cupom).
 *
 * - Só abre depois de alguns segundos (ou quando a pessoa já rolou 40% da página), nunca de cara.
 * - Quem fecha não vê de novo por N dias; quem se cadastrou não vê de novo por 1 ano.
 * - Depois de enviar o e-mail, a página recarrega e o popup abre já com o cupom.
 * - Eventos: signup_offer_view, signup_offer_google_click, copy_coupon (dataLayer).
 */
(() => {
  const dialog = document.querySelector('[data-signup-offer]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const KEY = 'itals_signup_offer';
  const DAY = 86400000;
  const track = (event, data = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
  };
  const read = () => {
    try {
      return Number(localStorage.getItem(KEY)) || 0;
    } catch (error) {
      return 0;
    }
  };
  const hideFor = (days) => {
    try {
      localStorage.setItem(KEY, String(Date.now() + days * DAY));
    } catch (error) {
      /* sem armazenamento: o popup pode voltar em outra visita, sem problema */
    }
  };

  const hasCouponState = Boolean(dialog.querySelector('[data-signup-offer-success]'));
  // Abre na hora só logo depois de enviar o formulário; quem já tem conta e volta depois segue o fluxo normal.
  const justSubscribed = hasCouponState && location.search.includes('customer_posted=true');
  const hasError = Boolean(dialog.querySelector('.signup-offer__error'));
  const days = Number(dialog.dataset.days) || 7;
  let opened = false;

  const open = () => {
    if (opened || dialog.open) return;
    opened = true;
    dialog.showModal();
    track('signup_offer_view', { state: hasCouponState ? 'coupon' : 'form' });
    dialog.querySelector('[data-signup-offer-success], input[type="email"]')?.focus();
  };

  dialog.addEventListener('close', () => hideFor(hasCouponState ? 365 : days));

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close(); // clique fora
  });
  dialog.querySelectorAll('[data-signup-offer-close]').forEach((element) => {
    element.addEventListener('click', () => dialog.close());
  });

  dialog.querySelector('[data-signup-offer-google]')?.addEventListener('click', () => {
    hideFor(365);
    track('signup_offer_google_click');
  });

  dialog.querySelector('[data-signup-offer-copy]')?.addEventListener('click', async (event) => {
    const button = event.currentTarget;
    try {
      await navigator.clipboard.writeText(dialog.dataset.coupon);
      const label = button.textContent;
      button.textContent = button.dataset.copiedLabel;
      setTimeout(() => (button.textContent = label), 2000);
    } catch (error) {
      /* sem permissão para copiar: o código continua visível */
    }
    track('copy_coupon', { code: dialog.dataset.coupon, location: 'signup_offer' });
  });

  // Editor do tema, cadastro recém-feito ou erro no e-mail: abre na hora.
  if ('designMode' in dialog.dataset || justSubscribed || hasError) {
    if (justSubscribed || hasError || document.readyState !== 'loading') open();
    else document.addEventListener('DOMContentLoaded', open, { once: true });
    return;
  }

  if (read() > Date.now()) return;

  const delay = (Number(dialog.dataset.delay) || 8) * 1000;
  const timer = setTimeout(open, delay);
  window.addEventListener(
    'scroll',
    () => {
      const scrolled = window.scrollY / Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      if (scrolled > 0.4) {
        clearTimeout(timer);
        open();
      }
    },
    { passive: true }
  );
})();
